import styled from 'styled-components';

import { primaryButtonStyles, secondaryButtonStyles, pillButtonStyles } from './component-styles/button';

const Button = styled.button`
  ${({ buttonstyle }) => (buttonstyle === 'secondary' ? secondaryButtonStyles : buttonstyle === 'pill' ? pillButtonStyles : primaryButtonStyles)}
`;

export { Button };
